import { toKstDate } from "shared/lib/date/formatKst";

/**
 * 문의 데이터의 기간 필터링과 처리율 계산을 담당하는 훅
 */
export const useInquiries = ({ inquiries, startDate, endDate }) => {
  const filteredInquiries = inquiries?.filter((inquiry) => {
    // createdAt은 서버가 UTC로 생성하므로 KST 보정 후 기간 비교(startDate/endDate는 KST).
    const createdAt = toKstDate(inquiry.createdAt); // 작성일자

    return createdAt && createdAt >= startDate && createdAt <= endDate;
  });

  const waitingCount = inquiries?.filter((item) => item.status === 0)?.length; // 대기 중인 건의 글 개수
  const inProgressCount = inquiries?.filter(
    (item) => item.status === 1,
  )?.length; // 진행 중인 건의 글 개수

  const inquiriesPer =
    inquiries?.length === 0
      ? 0
      : ((waitingCount + inProgressCount) * 100) / inquiries?.length; // 대기 중인 건의와 진행 중인 건의 글의 합
  const inquiriesPer1 = waitingCount + inProgressCount;

  return { filteredInquiries, inquiriesPer, inquiriesPer1 };
};
